// Sezione consumi energetici: consumo annuo, costo medio e dettaglio mensile
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

const MESI_LABELS = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
const MESI_KEYS = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];

export const ConsumiSection = ({ quote, isEditable, onUpdateSupplyData, onUpdateQuote }) => (
    <div className="space-y-3">
        <Label className="text-base font-semibold">Consumi Energetici</Label>
        <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
                <Label>Consumo Annuo (kWh)</Label>
                <Input
                    type="number"
                    value={quote.supply_data?.consumo_totale_kwh || quote.plant_data?.consumo_annuo_kwh || ''}
                    onChange={(e) => {
                        const val = parseFloat(e.target.value);
                        onUpdateSupplyData('consumo_totale_kwh', val);
                        onUpdateQuote({ plant_data: { ...quote.plant_data, consumo_annuo_kwh: val }});
                    }}
                    placeholder="4500"
                    disabled={!isEditable}
                />
            </div>
            <div className="space-y-2">
                <Label>Costo Medio (€/kWh)</Label>
                <Input
                    type="number"
                    step="0.01"
                    value={quote.supply_data?.costo_medio_kwh || quote.plant_data?.prezzo_energia_kwh || ''}
                    onChange={(e) => {
                        const val = parseFloat(e.target.value);
                        onUpdateSupplyData('costo_medio_kwh', val);
                        onUpdateQuote({ plant_data: { ...quote.plant_data, prezzo_energia_kwh: val }});
                    }}
                    placeholder="0.25"
                    disabled={!isEditable}
                />
            </div>
        </div>

        {/* Consumi Mensili */}
        {quote.supply_data?.consumi_mensili_kwh && Object.values(quote.supply_data.consumi_mensili_kwh).some(v => v) && (
            <div className="mt-4">
                <Label className="text-sm text-zinc-500">Consumi Mensili (kWh)</Label>
                <div className="grid grid-cols-6 gap-2 mt-2">
                    {MESI_LABELS.map((mese, idx) => {
                        const valore = quote.supply_data?.consumi_mensili_kwh?.[MESI_KEYS[idx]];
                        return (
                            <div key={mese} className="text-center p-2 bg-zinc-50 rounded">
                                <div className="text-xs text-zinc-500">{mese}</div>
                                <div className="font-medium">{valore || '-'}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        )}
    </div>
);
